/* eslint-disable react/jsx-no-bind */
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-light-svg-icons';

// actions + utils
import { loadAgents } from '../../actions/agent';
import { getAgencies } from '../../actions/agency';
import { castDirectionToBool } from '../../common/utils/cast';

// components
import TableFilter from './TableFilter';
import UserTable from './UserTable';
import AddUserModal from './add-user';
import DetailsModal from './user-details';
import AppointmentProfileReportsModal from './appointment-profile-modal';

function Admin() {
  const dispatch = useDispatch();
  const {
    can_add_users: canAdd,
    is_admin: isAdmin,
  } = useSelector(store => store.user);
  const {
    agentRegistration,
    appointmentsProfile,
  } = useSelector(store => store.theme.features);
  const {
    searchTerm: storeSearchTerm,
    agencyFilter: storeAgencyFilter,
    accountTypeFilter: storeAccountTypeFilter,
    sortInverse,
    activePage,
    sortTerm,
    selectedAgent = {},
    updatedStartDate: storeUpdatedStartDate,
    updatedEndDate: storeUpdatedEndDate,
    isRegisteredFilter: storeIsRegisteredFilter = (agentRegistration ? 'all' : undefined),
  } = useSelector(store => store.agents);
  const [ loading, setLoading ] = useState(false);
  const [ errorMessage, setErrorMessage ] = useState();

  function castRegisteredFlagToBool(flag) {
    if (flag === 'registered') return true;
    if (flag === 'unregistered') return false;
    return undefined;
  }

  function handleLoadAgents({
    key = sortTerm,
    direction = sortInverse,
    page = activePage,
    searchTerm = storeSearchTerm,
    agencyFilter = storeAgencyFilter,
    updatedStartDate = storeUpdatedStartDate,
    updatedEndDate = storeUpdatedEndDate,
    isRegisteredFilter = storeIsRegisteredFilter,
    accountTypeFilter = storeAccountTypeFilter,
    sort,
  } = {}) {
    setLoading(true);
    setErrorMessage('');
    loadAgents({
      page,
      agency: agencyFilter,
      desc: castDirectionToBool(direction),
      search_term: searchTerm,
      sort: (key || sort),
      last_updated_start: updatedStartDate,
      last_updated_end: updatedEndDate,
      registered: castRegisteredFlagToBool(isRegisteredFilter),
      is_admin: (accountTypeFilter === 'is_admin') ? true : undefined,
      is_agency_admin: (accountTypeFilter === 'is_agency_admin') ? true : undefined,
    })
      .then(data => dispatch({ type: 'LOAD_AGENT_LIST', payload: data }))
      .catch(() => setErrorMessage('Error loading agents'))
      .finally(() => setLoading(false));
  }

  useEffect(() => {
    dispatch({ type: 'FILTER', term: '' });
    dispatch({ type: 'CLEAR_AGENT_LIST' });
    dispatch({ type: 'CLEAR_SEARCH_TERM' });
    dispatch({ type: 'CLEAR_AGENT_SORT_TERM' });
    dispatch({ type: 'CLEAR_AGENT_SORT_INVERSE' });
    dispatch({ type: 'CLEAR_SELECTED_AGENTS' });
    dispatch({ type: 'SET_AGENCY_FILTER', payload: '' });
    dispatch({ type: 'SET_INITIAL_SELECT', payload: true });
    setLoading(true);
    handleLoadAgents();
    if (isAdmin) getAgencies();
  }, []);

  return (
    <>
      {/* <SelectedUserSideBar /> */}
      <main className="p-5">
        <div className="row justify-content-between">
          <div className="col">
            <h2 className="mb-3 fw-bold">User Administration</h2>
          </div>
          <div className="col-auto">
            {appointmentsProfile && (
              <button
                type="button"
                className="btn btn-primary me-3"
                onClick={() => dispatch({ type: 'OPEN_MODAL', modal: 'appointmentProfileReportsModal' })}
              >
                Appointment Profile Reports
              </button>
            )}
            {canAdd && (
              <button
                type="button"
                className="btn btn-secondary ms-2"
                onClick={() => dispatch({ type: 'OPEN_ADD_USER' }) && dispatch({ type: 'CHANGE_ADD_USER_PAGE', page: 'info' })}
              >
                <FontAwesomeIcon icon={faPlus} size="lg" className="me-2" />
                Add User
              </button>
            )}
          </div>
        </div>
        <div className="row">
          <div className="col">
            <div className="border bg-white pt-4 h-100 shadow-sm">
              <div className="row mb-4">
                <TableFilter handleLoadAgents={handleLoadAgents} />
              </div>

              <hr />

              <div className="row">
                <div className="col">
                  <UserTable
                    handleLoadAgents={handleLoadAgents}
                    loading={loading}
                    errorMessage={errorMessage}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <AddUserModal />
        <AppointmentProfileReportsModal />
        <DetailsModal user={selectedAgent} />
      </main>
    </>
  );
}

export default Admin;
